import React from 'react';

const Salary = React.lazy(() => import('pages/Salary/SalaryPage.jsx'));

const SalaryRoute = [
  ['/salary', 'Tính lương'],
  ['/salary-types', 'Loại lương'],
  ['/salary-assignments', 'Gán lương'],
  ['/salary-insurance', 'Khai báo bảo hiểm'],
  ['/salary-attendance', 'Công và quy đổi'],
  ['/salary-tax', 'Thuế thu nhập cá nhân'],
  ['/salary-sources', 'Nguồn thu nhập và tạm ứng'],
  ['/hr-reward-discipline', 'Khen thưởng và kỷ luật'],
].map(([path, name]) => ({ path, name, exact: true, function: 'SA_PAYROLL_VIEW', component: Salary }));

export default SalaryRoute;
